<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card outlined>
          <v-card-text>
            <v-data-table
              height="70vh"
              fixed-header
              dense
              :headers="headers"
              :items="items"
              hide-default-footer
              item-key="id"
              show-select
              v-model="selected"
              class="v-data-table-outlined"
            >
              <template v-slot:top>
                <v-toolbar flat dense>
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="deleteClick()"
                        color="red"
                        :disabled="selected.length === 0"
                        icon
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('delete') }}</span>
                  </v-tooltip>
                  <InfoSettingModify class="float-right" @persist="refresh" />
                </v-toolbar>
              </template>
              <template v-slot:[`item.modify`]="{ item }">
                <!-- eslint-disable-next-line  -->
                <InfoSettingModify v-model="item" @persist="refresh" />
              </template>
              <template v-slot:[`item.delete`]="{ item }">
                <v-checkbox v-model="item.delete" hide-details class="ma-0"></v-checkbox>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import InfoSettingModify from '@/views/InfoSettingModify.vue';
  import { mapGetters } from 'vuex';

  export default {
    title() {
      return this.$t(this.$route.meta.title);
    },
    name: 'Table',
    components: {
      InfoSettingModify,
    },
    data: () => ({
      items: [],
      selected: [],
    }),
    filters: {},
    computed: {
      ...mapGetters('auth', ['user_info']),
      headers() {
        return [
          { text: this.$t('notifications'), align: 'start', value: 'infoNm', sortable: false },
          { text: `${this.$t('from')}(UTC)`, align: 'start', value: 'startDatetime', sortable: false },
          { text: `${this.$t('to')}(UTC)`, align: 'start', value: 'endDatetime', sortable: false },
          { text: this.$t('edit'), align: 'start', value: 'modify', sortable: false },
        ];
      },
    },
    async created() {
      if ('Q118800Admin@user.kobelink.com' !== this.user_info.userId) {
        await this.$router.replace({
          name: 'NotFound',
        });
      }

      this.refresh();
    },
    methods: {
      async getInfomations() {
        this.$store.commit('loading/start_loading');
        console.info('Azure API開始');
        try {
          const info = await this.azureRequest('/api/getInformations', 'GET');

          // 削除直後で生存期間が残っていることを考慮してttlのチェック
          this.items = info
            .filter((el) => el.ttl === -1)
            .map((el) => {
              el.startDatetime = this.$moment(el.startDatetime).format('YYYY-MM-DD');
              el.endDatetime = this.$moment(el.endDatetime).format('YYYY-MM-DD');

              return el;
            });
        } catch (error) {
          console.error(error);
        } finally {
          console.info('Azure API完了');
          this.$store.commit('loading/end_loading');
        }
      },
      async deleteClick() {
        const deleteList = this.selected;

        this.$store.commit('loading/start_loading');
        console.info('Azure API開始');
        try {
          for (const el of deleteList) {
            await this.azureRequest('/api/deleteInformation', 'DELETE', {
              id: el.id,
              infoFile: el.infoFile ? el.infoFile : '',
              _ts: el._ts,
            });
            console.log('削除:' + el.id);
          }
        } catch (error) {
          console.error(error);
        } finally {
          console.info('Azure API完了');
          this.$store.commit('loading/end_loading');
        }
        this.refresh();
      },
      refresh() {
        this.getInfomations();
      },
    },
  };
</script>
<style scoped></style>
